import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnChartDashboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="m7.217 14.72 2.806-3.647 3.2 2.514 2.745-3.543m-1.553-6.255H7.603c-2.822 0-4.573 2-4.573 4.822v7.576C3.03 19.009 4.746 21 7.603 21h8.065c2.823 0 4.573-1.99 4.573-4.813V9.589m.73-4.787a1.802 1.802 0 1 1-3.604 0 1.802 1.802 0 0 1 3.603 0"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnChartDashboard;
